import React from "react";

import Badge from "../Badge";
import { ItemWrapper, RemoveButton, Slash, TrashIcon } from "./styles";
import { useDispatch } from "react-redux";
import {
  removeNewProjectSelectedDataset,
  requestDatasetRemove,
  setDatasetPreview,
} from "../../store/slices/datasets";
import { FileLibraryItem } from "../../models/Files";
import { getIconSrc } from "../../helpers/getIconType";
import { PreviewButton, SlashPreview } from "../Modals/CreateProject/styles";
import { DotSeparator } from "../ProjectMenu/styles";

interface DatasetsItemInterface {
  dataset?: Partial<FileLibraryItem>;
  id?: string;
  filePath?: string;
  hideRemove?: boolean;
  selectedDimensions?: string[] | undefined;
  currentKeys?: string[];
  isDraggable?: boolean;
  disablePreview?: boolean;
}
export const DatasetsItem = ({
  dataset,
  id,
  filePath,
  hideRemove,
  selectedDimensions,
  currentKeys,
  disablePreview,
  isDraggable,
}: DatasetsItemInterface) => {
  const dispatch = useDispatch();
  const onPreview = () => {
    dispatch(setDatasetPreview(dataset));
    // to do: call dataset preview
  };

  return (
    <ItemWrapper>
      {/* <FileName>{dataset?.name}</FileName> */}
      {dataset?.fields?.map((field, idx: number) => (
        <Badge
          key={idx}
          name={field.label}
          onClick={() => {}}
          keyName={field.key}
          type={field.type}
          subtype={field.subtype}
          icon={getIconSrc({ type: field.type, subtype: field.subtype })}
          isDraggable={isDraggable}
          selectedItems={selectedDimensions}
        />
      ))}
      {!disablePreview && (
        <>
          <DotSeparator $ml={"5px"} />
          <PreviewButton onClick={onPreview}>
            <SlashPreview />
            Preview
            <SlashPreview />
          </PreviewButton>
        </>
      )}
      {(id || filePath) && !hideRemove && (
        <RemoveButton
          onClick={() => {
            if (id) {
              dispatch(requestDatasetRemove(id));
            } else if (filePath) {
              dispatch(removeNewProjectSelectedDataset(filePath));
            }
          }}
        >
          <Slash /> Remove
          <TrashIcon />
          <Slash />
        </RemoveButton>
      )}
    </ItemWrapper>
  );
};
